export default function () {
  this.processing = true
  this.$http
    .post(this.pageSettings.webService, this.input)
    .then((res) => {
      this.alertNotice({
        type: 'success',
        title: 'Success',
        content: 'Create successfully.',
      })

      if( typeof this.afterSaveSuccess !== 'undefined')
        this.afterSaveSuccess(res)
      else
        this.$router.push({ name: this.pageSettings.sectionName + '.index' })
      
    })
    .catch((err) => {
      this.alertNotice({
        type: 'danger',
        title: 'Failed',
        content: err.data,
      })
      this.processing = false
    })
    .finally()
}